module.exports = __webpack_public_path__ + "pdf/ceo.5041618.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/ceo.pdf
// module id = 8XN8
// module chunks = 0